/* eslint-disable jsx-a11y/anchor-is-valid */
import {yupResolver} from '@hookform/resolvers/yup'
import moment from 'moment'
import {SnackbarProvider} from 'notistack'
import {FC, useEffect, useMemo, useState} from 'react'
import {FormProvider, useForm} from 'react-hook-form'
import {Column} from 'react-table'
import {KTCard, KTSVG} from '../../../../../../../_metronic/helpers'
import {
  KTable,
  KTableHeader,
  KTableLoading,
  KTableSelectionCellNonMultiple,
} from '../../../../../components/UI'
import {Button, ButtonWrapper} from '../../../../../components/UI/Button'
import {InputDate} from '../../../../../components/UI/Input'
import {Select} from '../../../../../components/UI/Select'
import {KTableProvider, useKTable} from '../../../../../contexts/KTableProvider'
import {useHoteleria} from '../../../../../hooks/useHoteleria'
import {useKhipu} from '../../../../../hooks/useKhipu'
import {checkInListSchema} from '../../../../../util/validationHoteleria'
import {useCentralServices} from '../../../hooks/useCentralServices'
import {CheckingModel} from '../../../models/ckecking.model'
import {getListCheckInExcelService} from '../../../services/booking.service'
import {getCheckingService} from '../../../services/checking.service'
import {paginationGuestsService} from '../../guests/services'
import {getMasterModuleService} from '../../modules/services'
import {CheckInListFiltersModel} from '../model/checkInList.model'
import {ModalCheckInDetail} from './Modal/ModalCheckInDetail'
import {ModalRePrintCI} from './Modal/ModalRePrintCI'
import {getSnackBarToast} from '../../../../../util/snackBar'

interface SelectOption {
  value: string | number | undefined
  label: string | undefined
}

const TableCheckInList: FC = () => {
  const {
    data,
    setData,
    setPagination,
    loading,
    setLoading,
    pagination,
    updateTable,
    setUpdateTable,
    clearTable,
    setClearTable,
    selectedOn,
  } = useKTable()
  const methods = useForm<CheckInListFiltersModel>({
    resolver: yupResolver(checkInListSchema),
    defaultValues: {
      EstadoReservaId: '',
      CompaniaId: '',
      ClienteId: '',
      CampamentoId: '',
      SiteId: '',
    },
  })
  const {
    control,
    formState: {errors},
    register,
    setValue,
    handleSubmit,
    setError,
    reset,
    // watch,
  } = methods
  const {currentTabItem, setShowModalSearch, isAllowed} = useHoteleria()
  const {searchValues, clearSearchValues} = useKhipu()
  const [formValue, setFormValue] = useState<any>(null)
  const [formValueLoading, setFormValueLoading] = useState<any>(false)

  const [compani, setCompany] = useState<SelectOption[]>([{value: '', label: 'TODOS'}])
  const [client, setClient] = useState<SelectOption[]>([{value: '', label: 'TODOS'}])
  const [site, setSite] = useState<SelectOption[]>([{value: '', label: 'TODOS'}])
  const [camp, setCamp] = useState<SelectOption[]>([{value: '', label: 'TODOS'}])
  const [bedTypes, setBedTypes] = useState<SelectOption[]>([])
  const [statusType, setStatusType] = useState<SelectOption[]>([])
  const [statusDetail, setStatusDetail] = useState<SelectOption[]>([])
  const [guest, setGuest] = useState<SelectOption[]>([])
  const [checkIn, setCheckIn] = useState<CheckingModel | any>()
  const [showModal, setShowModal] = useState(false)
  const [loadingExport, setLoadingExport] = useState(false)
  const [showModalPrint, setShowModalPrint] = useState(false)
  const [itemToEdit, setItemToEdit] = useState(null)
  const {getCompanies, getClients, getSites, getCamps} = useCentralServices()

  const getCompaniesFn = async () => {
    const data = await getCompanies({isCombo: true}, 1)
    if (data.length === 1) {
      setValue('CompaniaId', data[0].value as string)
      setError('CompaniaId', {})
      await getClientsFn(data[0].value as string)
    }
    const allData = [{value: '', label: 'TODOS'}, ...data]
    setCompany(allData)
  }

  const getClientsFn = async (companyId: string) => {
    const data = await getClients({isCombo: true, companiaId: companyId}, 1)
    if (data.length === 1) {
      setValue('ClienteId', data[0].value as string)
      setError('ClienteId', {})
      await getSitesFn(data[0].value as string)
    }
    const allData = [{value: '', label: 'TODOS'}, ...data]
    setClient(allData)
  }

  const getSitesFn = async (clientId: string) => {
    const data = await getSites({isCombo: true, clienteId: clientId}, 1)
    if (data.length === 1) {
      setValue('SiteId', data[0].value as string)
      setError('SiteId', {})
      await getCampsFn(data[0].value as string)
    }
    const allData = [{value: '', label: 'TODOS'}, ...data]
    setSite(allData)
  }

  const getCampsFn = async (siteId: string) => {
    const data = await getCamps({isCombo: true, siteId: siteId}, 1)
    if (data.length === 1) {
      setValue('CampamentoId', data[0].value as string)
      setError('CampamentoId', {})
    }
    const allData = [{value: '', label: 'TODOS'}, ...data]
    setCamp(allData)
  }

  const getBedTypes = async () => {
    try {
      const response = await getMasterModuleService({
        pageNumber: 1,
        size: 100,
        tableName: 'TipoCama',
      })
      const data = response.data.data
      const mappedMaster = data.map((master) => ({
        value: master.id,
        label: master.nombreCorto,
      }))
      setBedTypes(mappedMaster)
    } catch (error) {
      setBedTypes([])
    }
  }

  const getStatusDetail = async () => {
    try {
      const response = await getMasterModuleService({
        pageNumber: 1,
        size: 100,
        tableName: 'EstadoReservaCamaHuesped',
      })
      const data = response.data.data || []
      const filterData = data.filter((item) => item.codigo !== '7' && item.codigo !== '5')
      const mappedModuleTypes = filterData?.map((moduleType) => ({
        value: moduleType.id,
        label: moduleType.nombreCorto,
      }))
      setStatusDetail(mappedModuleTypes)
    } catch (error) {
      setStatusType([])
    }
  }
  const getStatusTypes = async () => {
    try {
      const response = await getMasterModuleService({
        pageNumber: 1,
        size: 100,
        tableName: 'EstadoReservaHuesped',
      })
      const data = response.data.data
      const filterData = data?.filter(
        (moduleType) =>
          moduleType.codigo === '2' || moduleType.codigo === '3' || moduleType.codigo === '9',
      )
      const mappedModuleTypes = filterData?.map((moduleType) => ({
        value: moduleType.id,
        label: moduleType.nombreCorto,
      }))
      const allData = [{value: '', label: 'TODOS'}, ...mappedModuleTypes]
      setStatusType(allData)
    } catch (error) {
      setStatusType([])
    }
  }

  const getGuests = async (siteId: string) => {
    try {
      const {data: response} = await paginationGuestsService({
        pageNumber: 1,
        size: 2000,
        SiteId: siteId,
      })
      if (!response.error) {
        const mappedGuests = response.data?.map((guest) => ({
          value: guest.Id,
          label: `${guest.Nombres} ${guest.ApellidoPaterno} ${guest.ApellidoMaterno}`,
        }))
        setGuest(mappedGuests)
      }
    } catch (error) {
      setGuest([])
    }
  }

  ///

  const getChekings = async () => {
    setShowModalSearch(false)
    try {
      if (!formValue) return
      setLoading(true)
      // changeSearchValues({})
      let obj = {...searchValues, ...formValue}
      let obj2 = {...obj}
      for (var clave in obj2) {
        if (obj2.hasOwnProperty(clave)) {
          if (obj2[clave] === '') {
            obj2[clave] = null
          }
        }
      }
      if (formValue?.EstadoReservaId === '') {
        obj2 = {...obj2, EstadoTodosConsultaCheckIn: true}
      } else {
        obj2 = {...obj2, EstadoTodosConsultaCheckIn: false}
      }
      const {data: response} = await getCheckingService({
        pageNumber: pagination.currentPage,
        size: pagination.perPage,
        ...obj2,
      })
      if (!response.error) {
        setData(response.data)
        setPagination({
          ...pagination,
          totalResults: response.total,
        })
      }
      setLoading(false)
    } catch (error) {
      setLoading(false)
    }
  }

  const handleFilterClient = (e: any) => {
    let value = e.value
    setValue('ClienteId', '')
    setValue('SiteId', '')
    setValue('CampamentoId', '')
    getClientsFn(value)
    setValue('CompaniaId', value)
    setError('CompaniaId', {})

    setClient([])
  }

  const handleFilterSite = (e: any) => {
    let value = e.value
    setValue('SiteId', '')
    setValue('CampamentoId', '')
    getSitesFn(value)
    setValue('ClienteId', value)
    setError('ClienteId', {})
  }

  const handleFilterCamp = (e: any) => {
    let value = e.value
    setValue('CampamentoId', '')
    getCampsFn(value)
    setValue('SiteId', value)
    setError('SiteId', {})
    // getGuests(value)
  }
  const handleFilterGuest = (e: any) => {
    let value = e.value
    setValue('CampamentoId', value)
    setError('CampamentoId', {})
  }
  const handleShowDetail = (item: CheckingModel) => {
    setCheckIn(item)
    setShowModal(true)
  }

  useEffect(() => {
    getChekings()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pagination.currentPage])

  const handleGetId = (datos: any) => {
    setItemToEdit(datos)
  }

  const columns: Column<CheckingModel>[] = useMemo(
    () => [
      {
        Header: (props) => <KTableHeader tableProps={props} />,
        id: 'selection',
        Cell: ({...props}) => (
          <KTableSelectionCellNonMultiple
            id={props.data[props.row.index].ReservaCamaId}
            clickHandler={() => handleGetId(props.data[props.row.index])}
          />
        ),
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='N° Reserva'
            name='NroReserva'
            searcheable
            number
          />
        ),
        accessor: 'CodigoReserva',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Nomenclatura de Módulo'
            name='CodigoModulo'
            searcheable
          />
        ),
        accessor: 'Modulo',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Nomenclatura de Habitación'
            name='CodigoHabitacion'
            searcheable
          />
        ),
        accessor: 'Habitacion',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Nomenclatura de Cama'
            name='CodigoCama'
            searcheable
          />
        ),
        accessor: 'CodigoCama',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Tipo de cama'
            name='TipoCamaId'
            selecteable
            data={bedTypes}
          />
        ),
        accessor: 'CamaTipo',
      },

      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Huésped'
            name='HuespedNombres'
            searcheable
            // data={guest}
          />
        ),
        accessor: 'HuespedDescripcion',
      },

      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Estado'
            name='EstadoReservaCamaId'
            data={statusDetail}
            selecteable
          />
        ),
        accessor: 'Estado',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Fecha Inicio Programada'
            name='FechaIni'
            dateable
          />
        ),
        accessor: 'FechaInicio',
      },
      {
        Header: (props) => (
          <KTableHeader tableProps={props} title='Fecha Fin Programada' name='FechaFin' dateable />
        ),
        accessor: 'FechaFin',
      },
      {
        Header: (props) => (
          <KTableHeader tableProps={props} title='Fecha Check in' name='FechaCheckIn' dateable />
        ),
        accessor: 'FechaCheckIn',
      },
      {
        Header: (props) => (
          <KTableHeader tableProps={props} title='Fecha Check out' name='FechaCheckOut' dateable />
        ),
        accessor: 'FechaCheckOut',
      },
      {
        Header: (props) => <KTableHeader tableProps={props} title='Ver' />,
        id: 'actions_ver',
        Cell: ({...props}) =>
          currentTabItem.fromOtherApp ? (
            <div
              className='d-flex justify-content-center flex-shrink-0'
              onClick={() => handleShowDetail(props.row.original)}
            >
              <a href='#' className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'>
                <KTSVG path='/media/icons/duotune/general/gen055.svg' className='svg-icon-3' />
              </a>
            </div>
          ) : isAllowed('EDITAR') ? (
            <div
              className='d-flex justify-content-center flex-shrink-0'
              onClick={() => handleShowDetail(props.row.original)}
            >
              <a href='#' className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'>
                <KTSVG path='/media/icons/duotune/general/gen055.svg' className='svg-icon-3' />
              </a>
            </div>
          ) : (
            <></>
          ),
      },
    ],
    [bedTypes, guest, selectedOn, statusDetail],
  )

  useEffect(() => {
    if (updateTable) {
      if (pagination.currentPage === 1) {
        getChekings()
      } else {
        setPagination({
          ...pagination,
          currentPage: 1,
          perPage: 10,
          totalResults: 0,
        })
      }
      setUpdateTable(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updateTable])

  useEffect(() => {
    getCompaniesFn()
    getBedTypes()
    getStatusTypes()
    getStatusDetail()
    // getGuests('')
    return () => {
      clearSearchValues()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (clearTable) {
      if (pagination.currentPage === 1) {
        getChekings()
      } else {
        setPagination({
          ...pagination,
          currentPage: 1,
          perPage: 10,
          totalResults: 0,
        })
      }
      setClient([])
      setSite([])
      setCamp([])
      // setData([])
      setClearTable(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clearTable])

  useEffect(() => {
    setLoading(loading)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading])
  useEffect(() => {
    if (formValueLoading) {
      setFormValueLoading(false)
      getChekings()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formValueLoading])

  const handleClear = () => {
    setClient([{value: '', label: 'TODOS'}])
    setSite([{value: '', label: 'TODOS'}])
    setCamp([{value: '', label: 'TODOS'}])
    reset()
    setFormValue(null)
    setData([])
    setClearTable(true)
    getStatusTypes()
  }

  const handleExport = async () => {
    try {
      let obj = {...searchValues, ...formValue}
      let obj2 = {...obj}
      for (var clave in obj2) {
        if (obj2.hasOwnProperty(clave)) {
          if (obj2[clave] === '') {
            obj2[clave] = null
          }
        }
      }
      if (formValue?.EstadoReservaId === '') {
        obj2 = {...obj2, EstadoTodosConsultaCheckIn: true}
      } else {
        obj2 = {...obj2, EstadoTodosConsultaCheckIn: false}
      }
      setLoadingExport(true)
      const response = await getListCheckInExcelService({
        pageNumber: pagination.currentPage,
        size: pagination.perPage,
        ...obj2,
      })
      const blob = new Blob([response.data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      })
      // Crea un enlace temporal y simula un clic para descargar el archivo
      moment().format('DD/MM/YY HH:mm').toString()
      const link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = `CheckIn-${moment().format('DD/MM/YY HH:mm').toString()}.xlsx` // Ajusta el nombre del archivo según tus necesidades
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      setLoadingExport(false)
    } catch (error) {
      getSnackBarToast('Hubo un error al descargar', 'error')
      setLoadingExport(false)
    }
  }

  const onSubmit = (dataForm: CheckInListFiltersModel) => {
    setPagination({
      ...pagination,
      currentPage: 1,
      perPage: 10,
      totalResults: 0,
    })
    setFormValue(dataForm)
    setFormValueLoading(true)
  }

  const handleRePrint = () => {
    setShowModalPrint(true)
  }
  return (
    <>
      {currentTabItem.fromOtherApp ? (
        <KTCard shadow className='m-5'>
          <>
            <FormProvider {...methods}>
              <form className='m-2'>
                <div className='row'>
                  <div className='col-sm-12 col-lg-3'>
                    <label className='required'>Compañía:</label>
                    <Select
                      control={control}
                      name='CompaniaId'
                      data={compani}
                      errors={errors}
                      onChangeValue={handleFilterClient}
                    />
                  </div>
                  <div className='col-sm-12 col-lg-3'>
                    <label className='required'>Cliente:</label>
                    <Select
                      control={control}
                      name='ClienteId'
                      data={client}
                      errors={errors}
                      onChangeValue={handleFilterSite}
                    />
                  </div>
                  <div className='col-sm-12 col-lg-3'>
                    <label className='required'>Site:</label>
                    <Select
                      control={control}
                      name='SiteId'
                      data={site}
                      errors={errors}
                      onChangeValue={handleFilterCamp}
                    />
                  </div>
                  <div className='col-sm-12 col-lg-3'>
                    <label className='required'>Campamento:</label>
                    <Select
                      control={control}
                      name='CampamentoId'
                      data={camp}
                      errors={errors}
                      onChangeValue={handleFilterGuest}
                    />
                  </div>
                  <div className='col-sm-12 col-lg-3'>
                    <label className='required'>Estado de reserva:</label>
                    <Select
                      control={control}
                      name='EstadoReservaId'
                      data={statusType}
                      errors={errors}
                    />
                  </div>
                  <div className='col-sm-12 col-lg-3'>
                    <label>Fecha Inicio de Reserva:</label>
                    <InputDate
                      name='FechaIni'
                      minValue={moment().subtract(1, 'month').format('YYYY-MM-DD')}
                      register={register}
                      errors={errors}
                    />
                  </div>
                  <div className='col-sm-12 col-lg-3'>
                    <label>Fecha Fin de Reserva:</label>
                    <InputDate name='FechaFin' register={register} errors={errors} />
                  </div>
                </div>
              </form>
              {/* <pre>{JSON.stringify(watch(), null, 2)}</pre> */}
              <ButtonWrapper className={'sdx-white-bg'}>
                <Button label='Buscar' onClick={handleSubmit(onSubmit)} />
                <Button label='Limpiar' onClick={handleClear} />
                <Button
                  label='Exportar'
                  onClick={handleExport}
                  disabled={data.length < 1 || loadingExport}
                  loading={loadingExport}
                />
                <Button
                  label='Re Imprimir'
                  onClick={handleRePrint}
                  disabled={selectedOn.length < 1}
                />
              </ButtonWrapper>
            </FormProvider>
          </>
          {loading ? <KTableLoading title='Cargando...' /> : null}
          <KTable data={data} columns={columns} clearFilters />
          {showModal ? (
            <ModalCheckInDetail
              show={showModal}
              setShow={setShowModal}
              checkIn={checkIn}
              getChekings={getChekings}
            />
          ) : (
            <></>
          )}
          {showModalPrint ? (
            <ModalRePrintCI
              show={showModalPrint}
              setShow={setShowModalPrint}
              itemToEdit={itemToEdit}
              getBookings={getChekings}
            />
          ) : (
            <></>
          )}
        </KTCard>
      ) : (
        <KTCard shadow className='m-5'>
          {isAllowed('BUSCAR_ENCABEZADO') && (
            <>
              <FormProvider {...methods}>
                <form className='m-2'>
                  <div className='row'>
                    <div className='col-sm-12 col-lg-3'>
                      <label className='required'>Compañía:</label>
                      <Select
                        control={control}
                        name='CompaniaId'
                        data={compani}
                        errors={errors}
                        onChangeValue={handleFilterClient}
                      />
                    </div>
                    <div className='col-sm-12 col-lg-3'>
                      <label className='required'>Cliente:</label>
                      <Select
                        control={control}
                        name='ClienteId'
                        data={client}
                        errors={errors}
                        onChangeValue={handleFilterSite}
                      />
                    </div>
                    <div className='col-sm-12 col-lg-3'>
                      <label className='required'>Site:</label>
                      <Select
                        control={control}
                        name='SiteId'
                        data={site}
                        errors={errors}
                        onChangeValue={handleFilterCamp}
                      />
                    </div>
                    <div className='col-sm-12 col-lg-3'>
                      <label className='required'>Campamento:</label>
                      <Select
                        control={control}
                        name='CampamentoId'
                        data={camp}
                        errors={errors}
                        onChangeValue={handleFilterGuest}
                      />
                    </div>
                    <div className='col-sm-12 col-lg-3'>
                      <label className='required'>Estado de reserva:</label>
                      <Select
                        control={control}
                        name='EstadoReservaId'
                        data={statusType}
                        errors={errors}
                      />
                    </div>
                    <div className='col-sm-12 col-lg-3'>
                      <label>Fecha Inicio de Reserva:</label>
                      <InputDate name='FechaIni' register={register} errors={errors} />
                    </div>
                    <div className='col-sm-12 col-lg-3'>
                      <label>Fecha Fin de Reserva:</label>
                      <InputDate name='FechaFin' register={register} errors={errors} />
                    </div>
                  </div>
                </form>
                {/* <pre>{JSON.stringify(watch(), null, 2)}</pre> */}
                <ButtonWrapper className={'sdx-white-bg'}>
                  <Button label='Buscar' onClick={handleSubmit(onSubmit)} />
                  <Button label='Limpiar' onClick={handleClear} />
                  <Button
                    label='Exportar'
                    onClick={handleExport}
                    disabled={data.length < 1 || loadingExport}
                    loading={loadingExport}
                  />
                  <Button
                    label='Re Imprimir'
                    onClick={handleRePrint}
                    disabled={selectedOn.length < 1}
                  />
                </ButtonWrapper>
              </FormProvider>
            </>
          )}
          {isAllowed('LISTAR') && (
            <>
              {loading ? <KTableLoading title='Cargando...' /> : null}
              <KTable data={data} columns={columns} clearFilters />
            </>
          )}
          {showModal ? (
            <ModalCheckInDetail
              show={showModal}
              setShow={setShowModal}
              checkIn={checkIn}
              getChekings={getChekings}
            />
          ) : (
            <></>
          )}
          {showModalPrint ? (
            <ModalRePrintCI
              show={showModalPrint}
              setShow={setShowModalPrint}
              itemToEdit={itemToEdit}
              getBookings={getChekings}
            />
          ) : (
            <></>
          )}
        </KTCard>
      )}
    </>
  )
}

const TableCheckInListWrapper = () => {
  return (
    <KTableProvider>
      <div className=''>
        <TableCheckInList />
      </div>
      <SnackbarProvider />
    </KTableProvider>
  )
}

export {TableCheckInListWrapper}
